export default __webpack_public_path__ + "static/media/loading-animation.d17b9de3.gif";